import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Highlights</span>
            </h2>
            <p>
              Along with an easy and intuitive process to register themselves,
              we also enabled users to upload their pictures and videos to
              create the best possible online portfolio.
            </p>
            <p>
              The website includes Casting Call section that help recruiters
              find their perfect team and users can also easily apply for the
              appropriate projects.
            </p>
            <p>
              We also integrated client’s social accounts on the website to help
              users easily follow Talpool on all channels.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/talpool/higlights_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1020}
              height={828}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
